import logo from "./logo.svg";
import "./App.css";
import AdminPage from "./Admin/AdminPage";
import AllRoutes from "./Routes/AllRoutes";
import Sample from "./Admin/Sample";
function App() {
  return (
    <div className="App">
      <AllRoutes />
    </div>
  );
}

export default App;
